import React, { useState } from "react";
import styled from "styled-components";
import Modal from "new_components/molecules/Modal";
import TextInput from "new_components/molecules/TextInput";
import Button from "new_components/atoms/Button";
import Text from "new_components/atoms/Text";

function DeleteModal({ isOpen, onClose, onConfirm, itemName, textOverride, headingOverride, confirmTextOverride }) {
  const [inputValue, setInputValue] = useState("");
  const isDeleteConfirmed = confirmTextOverride ? inputValue.trim().toLowerCase() === confirmTextOverride : inputValue.trim().toLowerCase() === "delete";

  const handleConfirm = () => {
    if (isDeleteConfirmed) {
      onConfirm();
      setInputValue("");
    }
  };

  // if textOverride is provided, parse it as HTML using DOMParser
  const parsedText = textOverride ? new DOMParser().parseFromString(textOverride, "text/html").body.innerHTML : null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose();
        setInputValue("");
      }}
      modalHeading={headingOverride || "Confirm Deletion"}
      modalHeight="280px"
      modalBody={
        <div>
          <TextWrapper>
            {!textOverride ? (
              <Text>
                Are you sure you want to delete <strong>{itemName}</strong>?
                This action cannot be undone.
              </Text>
            ) : (
              <Text dangerouslySetInnerHTML={{ __html: parsedText }} />
            )}
          </TextWrapper>
          <TextInput
            label={`Type ${confirmTextOverride || "delete"} to confirm`}
            placeholder={confirmTextOverride || "delete"}
            value={inputValue}
            onChange={setInputValue}
          />
        </div>
      }
      modalFooter={
        <FooterContainer>
          <Button
            variant="secondary"
            onClick={() => {
              onClose();
              setInputValue("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!isDeleteConfirmed}
          >
            {
              confirmTextOverride ? confirmTextOverride.charAt(0).toUpperCase() + confirmTextOverride.slice(1) : "Delete"
            }
          </Button>
        </FooterContainer>
      }
    />
  );
}

const TextWrapper = styled.div`
  margin-bottom: 16px;
`;

const FooterContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: right;
  width: 100%;
`;

export default DeleteModal;
